import React from 'react';
import PropTypes from 'prop-types';

export default class BizTag extends React.Component {

  static propTypes = {
    bottom: PropTypes.bool,
  };

  render() {

    let classname = "bizTag";
    if (this.props.bottom) {
      classname = "bizTag-bottom";
    }

    return (
      <span className={classname}>
      </span>
    )
  }

}